import * as Actions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case Actions.ERROR:
      return action.errors || action.error;
    default:
      return state;
  }
};
